// extracted by mini-css-extract-plugin
export default {"statusContainer":"src-pages-rule-pages-detail-components-ExcelInput-index-module_statusContainer--GYZrP"};